
import $ from "./jq";
export default class Video{
    constructor(){
        this.switcherSlt = ".j-vdeo-swiper";
        this.$switcher = $(".j-vdeo-swiper");
        this.$vdeoList = $(".j-vedio-list");
        this.$videos = $(".j-vdio");
        this.$video = document.createElement("video");
        this.curIndex = 0;
    }
    init(){
        let me = this;
        $(document).on("click",this.switcherSlt ,function(){
            me.switchVideo(this);
            me.stopAllVdeo();
            me.playBgVid();
            me.stopBgVid();
        })
    }
    
    stopAllVdeo(){
        for(let i = 0,len = this.$videos.length;i<len;i++){
            this.$videos.get(i).contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        }
    }

    playCur(){
        this.$videos.get(this.curIndex).contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');      
    }

    stopCur(){
        this.$videos.get(this.curIndex).contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
    }

    playBgVid(){
        document.querySelector(".j-bgVdeo").contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');  
    }

    stopBgVid(){
        document.querySelector(".j-bgVdeo").contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*'); 
    }

    switchVideo(el){
        let index = $(el).index();
        this.curIndex  = index;
        let windowW = $(window).width();
        let left = - index * windowW + "px";
        this.$switcher.removeClass("cur");
        $(el).addClass("cur");
        this.$vdeoList.css({
            "transform" :  `translateX(${left})`
        })
    }
}